module.exports = __webpack_public_path__ + "img/Frente-50-00 off.f0d565cd.png";